import LeftBar from "../../navbar/LeftBar";
import {useEffect, useState} from "react";
import axios from "axios";
import { Outlet } from 'react-router-dom';
import withAccess from "../../hoc/withAccess"
import {setError} from "../../../slices/error/ErrorSlice";
import {setDined} from "../../../slices/error/AccessSlice";
import {useDispatch} from "react-redux";

const Voc = () => {
    const dispatch = useDispatch();

    const[voc, setVoc] = useState([]);
    useEffect(() => {
        axios.get('/api/voc-list')
            .then(res => {
                setVoc(res.data)
            })
            .catch(e => {
                if (e.status === 403) {
                    dispatch(setDined(true));
                } else dispatch(setError(e.response.data));
            })
    }, []);

    return (
        <>
            <div id='sect_left'>
                <LeftBar head='Словари' data={voc} />
            </div>

            <div id='sect_right'>
                <Outlet />
            </div>
        </>
    )
}

const VocWithAccess = withAccess(Voc);

export default VocWithAccess;